import React from 'react';
import { Avatar, Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { UserNoAvatarIcon, LinkIcon } from '../../../../components/icons';
import { OrderData } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';

interface OfferCellProps {
  order: OrderData;
}

const OfferCell: React.FC<OfferCellProps> = ({ order }) => {
  const { t } = useTranslations();

  return (
    <div className="flex items-start gap-4">
      <Avatar
        src={order.offer.avatar}
        showFallback
        name={order.offer.name?.slice(0, 1)}
        className="w-8 h-8 rounded-lg"
      />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Typography variant="body2" className="text-gray-900">
            #{order.offer.id.slice(-4)}
          </Typography>
          <div className="flex items-center gap-1 text-blue-600">
            <Typography variant="body1" className="!text-partner !text-sm !font-medium">
              {order.offer.name}
            </Typography>
            {/* <LinkIcon className="w-5 h-5" /> */}
          </div>
        </div>

        <Chip
          variant="bordered"
          size="sm"
          className="border-auth-strength-none border-[1.4px] !h-6 rounded-xl w-fit"
          startContent={
            <div className="inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center [&_svg]:h-auto [&_svg]:w-full [&_svg]:max-h-full">
              {order.account.platformIcon}
            </div>
          }
        >
          <Typography variant="body3">{order.offer.platform}</Typography>
        </Chip>

        <div className="flex items-center gap-2">
          <Typography variant="body3" className="text-gray-600">
            {t('orders.offer.subscribers')}:
          </Typography>
          <Typography variant="body2" className="md:font-semibold text-gray-900">
            {order.offer.subscribers.toLocaleString()}
          </Typography>
        </div>

        <div className="flex items-center gap-2">
          <Typography variant="body3" className="text-gray-600">
            {t('orders.offer.pricePerSubscriber')}/
          </Typography>
          <Typography variant="body2" className="md:font-semibold text-gray-900">
            ${order.offer.pricePerSubscriber.toFixed(2)}
          </Typography>
        </div>

        <Typography variant="body2" className="text-gray-900 max-w-60">
          {order.offer.description}
        </Typography>
      </div>
    </div>
  );
};

export default OfferCell;
